import React, { useState } from "react";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { Outlet, useNavigate } from "react-router";
import Modal from "react-bootstrap/Modal";
import { MarketingNavbarComponent } from "../navbar";
import { useScrollContext } from "../../Utils/ScrollContext";
import "./layout.css";
import SearchBarComponent from "./Searchbarcomponent";
import { useSearch } from "../../Utils/SearchContext";

const DashboardLayout = () => {
    const navigate = useNavigate();
    const { triggerLoadMore } = useScrollContext();
    const [showLogout, setShowLogout] = useState(false);
    const { query, setQuery } = useSearch();

    const handleLogout = () => {
        localStorage.removeItem("token");
        setShowLogout(false);
        navigate("/");
    };

    const handleDashboardScroll = (e) => {
        const el = e.target;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
            triggerLoadMore();
        }
    };

    return (
        <>
            <div className="dashboard-layout">
                <header className="dashboard-header">
                    <div className="dashboard-brand">
                        <img
                            className="dashboard-logo"
                            src={require("./images/icclogo.webp")}
                            alt="India Casting Club"
                        />
                    </div>
                    <div className="dashboard-search">
                        <SearchBarComponent query={query} setQuery={setQuery} />
                    </div>
                    <div className="dashboard-right">
                        <button
                            type="button"
                            className="dashboard-logout-btn"
                            onClick={() => setShowLogout(true)}
                        >
                            <RiLogoutCircleRLine className="dashboard-logout-icon" />
                            <span>Logout</span>
                        </button>
                    </div>
                </header>

                <div className="dashboard-body">
                    <aside className="dashboard-sidebar">
                        <MarketingNavbarComponent />
                    </aside>

                    <main className="dashboard-content">
                        <div className="dashboard-inner" onScroll={handleDashboardScroll}>
                            <Outlet />
                        </div>
                    </main>
                </div>
            </div>

            <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
                <Modal.Body className="logout-modal-body">
                    <h5>Are you sure you want to logout?</h5>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        className="btn btn-secondary"
                        onClick={() => setShowLogout(false)}
                    >
                        Cancel
                    </button>
                    <button className="btn btn-primary" onClick={handleLogout}>
                        Ok
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export { DashboardLayout };
